// src/frameworks/react/index.ts

import type { FrameworkConfig, ProjectConfig } from "../../types/types.js"
import { BaseFramework } from "../base-framework.js"

const reactConfig: FrameworkConfig = {
  defaultMeta: "none",
  displayName: "React",
  metaFrameworks: ["next", "remix", "none"],
  name: "react",
  starter: {
    args: (config: ProjectConfig) => {
      const args: Array<string> = []

      if (config.typescript) {
        args.push("--template", "typescript")
      }

      return args
    },

    command: "create-react-app",
  },
}

export class ReactFramework extends BaseFramework {
  constructor() {
    super(reactConfig)
  }

  getStarterCommand(projectConfig: ProjectConfig): string {
    const { metaFramework } = projectConfig

    switch (metaFramework) {
      case "next":
        return this.getNextCommand(projectConfig)
      case "remix":
        return this.getRemixCommand(projectConfig)
      case "none":
        return this.getViteReactCommand(projectConfig)
    }
  }

  private getNextCommand(projectConfig: ProjectConfig): string {
    const { projectName, typescript } = projectConfig

    const args = [
      `"${projectName}"`,
      typescript ? "--ts" : "--js",
      "--app",
      "--no-git",
      "--skip-install",
      "--yes",
    ]

    return `npx create-next-app@latest ${args.join(" ")}`
  }

  private getRemixCommand(projectConfig: ProjectConfig): string {
    const { projectName, typescript } = projectConfig
    const args = [
      `"${projectName}"`,
      "--skip-install",
      typescript ? "--ts" : "--js",
      "--yes",
    ]

    return `npx create-remix@latest ${args.join(" ")}`
  }

  private getViteReactCommand(projectConfig: ProjectConfig): string {
    const { projectName, typescript } = projectConfig
    const template = typescript ? "react-ts" : "react"

    return `npm create vite@latest ${projectName} -- --template ${template}`
  }

  getPostInstallTasks(
    _projectConfig: ProjectConfig,
  ): Array<() => Promise<void>> {
    const tasks: Array<() => Promise<void>> = []

    // Only add post-install tasks if really needed
    // Most modern starters already have the correct scripts

    return tasks
  }
}
